export default {
  SET_NICHE_CATEGORIES: function (state, nicheCategories) {
    state.nicheCategories = nicheCategories;
  }
}
